import React from 'react'

interface CandyCaneDecorProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  size?: 'sm' | 'md' | 'lg'
}

const CandyCaneDecor: React.FC<CandyCaneDecorProps> = ({ 
  position = 'top-left',
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8 md:w-12 md:h-12',
    md: 'w-12 h-12 md:w-16 md:h-16',
    lg: 'w-16 h-16 md:w-20 md:h-20',
  }

  const positionClasses = {
    'top-left': 'top-0 left-0 -rotate-45',
    'top-right': 'top-0 right-0 rotate-45',
    'bottom-left': 'bottom-0 left-0 rotate-45',
    'bottom-right': 'bottom-0 right-0 -rotate-45',
  }

  return (
    <div className={`absolute ${positionClasses[position]} ${sizeClasses[size]} opacity-60 pointer-events-none`}>
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* 拐杖糖主體 */}
        <defs>
          <pattern id="candyStripes" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
            <rect width="4" height="8" fill="#dc2626" />
            <rect x="4" width="4" height="8" fill="#ffffff" />
          </pattern>
        </defs>
        
        {/* 拐杖糖形狀 */}
        <path
          d="M 70 30 
             A 20 20 0 0 0 30 30
             L 30 50
             A 5 5 0 0 0 40 50
             L 40 30
             A 10 10 0 0 1 60 30
             L 60 70
             A 5 5 0 0 1 50 75
             L 50 30
             A 15 15 0 0 1 70 30 Z"
          fill="url(#candyStripes)"
          stroke="#dc2626"
          strokeWidth="2"
        />
        
        {/* 亮光效果 */}
        <ellipse cx="45" cy="35" rx="8" ry="4" fill="white" opacity="0.4" />
      </svg>
    </div>
  )
}

// 創建包含多個拐杖糖的裝飾框架
export const CandyCaneFrame: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none">
      <CandyCaneDecor position="top-left" size="md" />
      <CandyCaneDecor position="top-right" size="md" />
      <CandyCaneDecor position="bottom-left" size="sm" />
      <CandyCaneDecor position="bottom-right" size="sm" />
    </div>
  )
}

export default CandyCaneDecor
